import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";

import { ReactComponent as ExternalLinkIcon } from "../../assets/external-link.svg";

export type RedirectLinkProps = {
  href: string;
  title?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

const RedirectLink: FC<RedirectLinkProps> = ({ children, href, title, style }) => {
  return (
    <Link href={href} title={title && title} style={style} target="_blank" rel="noopener noreferrer">
      {children}
      <RedirectIcon />
    </Link>
  );
};

const Link = styled.a`
  display: inline-flex;
  align-items: center;
`;

const RedirectIcon = styled(ExternalLinkIcon)`
  margin-left: 4px !important;
  width: 16px !important;
  height: 16px !important;
`;

export default RedirectLink;
